import { Icon } from "@iconify/react"
import { Button, Card, Grid, message, Pagination, Space, Table, Tag, Typography } from "antd"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { historyLogService } from "../../services/history-log.service";
import useTitleStore from "../../store/titleStore";
import { useTableHeight } from "../../hooks/useTableHeight";
import { format } from "date-fns";

export default function HistoryLogIndex(){

  const breakpoint = Grid.useBreakpoint()

  const navigate = useNavigate();
  const { setTitle } = useTitleStore();
  // const queryClient = useQueryClient();
  const tableHeight = useTableHeight(340);
  
  const [, contextHolder] = message.useMessage();
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    filter: []
  })

  const { data: informationData , isLoading, isRefetching } = useQuery({
    queryKey: ['cubicationCost', dataParams],
    queryFn: () => historyLogService.fetchAll(dataParams),
    placeholderData: keepPreviousData,
  })

  useEffect(() => {
    setTitle("Riwayat Aktivitas");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page
    })
  }

  const columns = [
    {
      title: 'No',
      align: 'center',
      // width: 80,
      width: breakpoint.md ? 80 : 40,
      render: (text, record, index) =>  index + 1,
      fixed: breakpoint.md && 'left'
    },
    {
      title: 'Module',
      dataIndex: 'module',
      width:230 ,
      fixed: breakpoint.md && 'left'
    },
    {
      title: 'Aksi',
      dataIndex: 'action',
      width: 120,
      render: val => {
        switch (val) {
          case 'CREATE':
            return <Tag color="success" >{val}</Tag>
          case 'UPDATE':
            return <Tag color="blue" >{val}</Tag>
          case 'DELETE':
            return <Tag color="red" >{val}</Tag>
        }
      }
    },
    {
      title: 'Updated By',
      width: 210,
      render: val => (
        <Space direction="vertical" size={2} >
          <Typography.Text style={{ marginBottom: 0, fontWeight: 400 }} >
            {val.user.name}
          </Typography.Text>
          <Typography.Text type="secondary" >
            {format(new Date(val.createdAt), 'dd/MM/yyyy - HH.mm')}
          </Typography.Text>
        </Space>
      )
    },
    {
      className: 'last-cell-p',
      title: 'Detail',
      align: 'right',
      width: 80,
      fixed: 'right',
      render: record => (
        <Button 
          size="small" 
          variant="filled" 
          color="primary" 
          onClick={() => navigate('/history-log/detail/'+record.id) }
          icon={
            <Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />
          }
        />
      )
    },
  ]



  return (
    <Card
      styles={{
        body: {
          paddingLeft: 0,
          paddingRight: 0
        }
      }}
    >
      {contextHolder}
      {/* <Flex justify="space-between" style={{ paddingInline: 24, marginBottom: 24 }} >
        <Input 
          style={{ width: 320 }} 
          prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
          placeholder="cari..."
          onChange={e => setKeyword(e.target.value)}
          value={keyword}
        />
        <Button 
          variant="solid" 
          color="primary"  
          icon={<Icon icon="duo-icons:add-circle" width="22" height="22" />}
          onClick={() => navigate('/bill-simulation/cubication-cost/create')}
        >
          Tambah Jenis Pelanggan
        </Button>
      </Flex> */}
      <Table
        columns={columns}
        pagination={false}
        size="small"
        loading={isLoading || isRefetching}
        rowKey={'id'}
        scroll={{ y: tableHeight }}
        dataSource={informationData?.data}
      />
       <Pagination
          style={{ marginInline: 24, marginTop: 16 }}
          total={informationData?.pagination?.total}
          showSizeChanger={{
            showSearch: false,
          }}
          pageSizeOptions={['10', '20', '50']}
          current={informationData?.pagination?.page}
          pageSize={dataParams.limit}
          align="end"
          onChange={handleChangePage}
        />
    </Card>
  )
}